export class ClusterModel {
  public code: number;
  public description: string;
}

export class CardModeModel {
  public code: string;
  public description: string;
}

export class DateListModel extends Map<Date, Date[]> {
  constructor() {
    super()
  }

}

export class GroupModel {
  public code: string;
  public description: string;
}

export class GroupTypeModel {
  public type: string;
  public code: string;
  public description: string;
  public groups: GroupModel[];
}

export class AreaModel {
  public code: number;
  public description: string;
}

export class StoreComboModel {
  public code: number;
  public description: string;
}



// WEBPACK FOOTER //
// ./src/app/services/analytics/analytics.model.ts